import React, { useEffect, useState } from 'react'
import Popup from '../../../../../components/popup/Popup'
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown'
import Button from '../../../../../components/button/Button'
import { BUTTON_TYPE } from '../../../../../components/button/constants'
import styles from "./BulkStateFiling.styles"
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setFormSelectionModal, setPaymentDrawerModal, setSelectedForm } from './BulkStateFilingSlice'
import { getBulkReferences, getBulkStateFiling } from './BulkStateFilingSaga'
import PaymentDrawer from '../../../../components/paymentdrawer/PaymentDrawer'
import { addNotifications } from '../../../../toaster/ToasterPortalSlice'
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../../../components/paymentdrawer/constants'
import useGarbageCollector from '../../../../../../libs/garbagecollector/garbageCollectorHooks'
import ManageFormsService from '../../../../../../services/ManageFormsService'
import General from '../../../../../../libs/utility/General'
import Loadable from '../../../../../components/loadable/Loadable'
import { PAGE_STATE } from '../../../../constants/constants'
import { setReloadGridData } from '../ManageFederalFormsSlice'

export const BulkStateFiling = ({
    isOpen = false,
    onCloseCb = () => { },
    formOptions = [],
    payerId = "",
    taxYear = "",
}) => {

    useGarbageCollector(componentKey)
    const dispatch = useDispatch();
    const { selectedForm, loadingState, bulkStateAmount, paymentDrawerModal, formSelectionModal, referenceList } = useSelector(state => state[componentKey]);

    const [uniqueReferenceList, setUniqueReferenceList] = useState([]);
    
    useEffect(() => {
        if (selectedForm?.FormName1 && payerId && taxYear) {
            dispatch(getBulkReferences({
                payerId,
                taxYear,
                formName: selectedForm?.FormName1,
            }));
        }
    }, [selectedForm]);

    useEffect(() => {
        if(referenceList.length > 0){
            const uniqueReferenceNumberArray = referenceList.reduce((accumulator, currentObject) => {
                const existingObjectIndex = accumulator.findIndex(item => item?.ReferenceID === currentObject?.ReferenceID);
                if (existingObjectIndex === -1) {
                    accumulator.push({ ReferenceID: currentObject.ReferenceID });
                }
                return accumulator;
            }, []);
            General.addOptionAndValueKeys(uniqueReferenceNumberArray, "ReferenceID", "ReferenceID")
            setUniqueReferenceList(uniqueReferenceNumberArray)
        }else{
            setUniqueReferenceList([])
        }
    }, [referenceList])

    const handleClose = () => {
        onCloseCb();
    }

    return (
        <>
            {isOpen && <>
                <Popup
                    title={"Bulk State Filing"}
                    isPopupOpen={formSelectionModal}
                    onCloseCb={handleClose}
                    childrenStyles={styles.childrenStyles}
                >

                    <SelectDropdown
                        name="FormName"
                        label='Form Name'
                        value={selectedForm}
                        onSelectCb={(name, selectedOption) => dispatch(setSelectedForm(selectedOption))}
                        options={formOptions}
                        dropdownMenuStyle={styles.dropdownMenu}
                    />
                    <Loadable currentState={loadingState.state} loadingStates={[PAGE_STATE.LOADING]} isNewLoadable={true}>
                        {selectedForm?.FormName1 && !referenceList.length ? <p style={styles.errorTxt}>No reference numbers were found for this form!</p> : null}
                        {
                            selectedForm?.FormName1 && referenceList.length && <div style={styles.referenceNumbersContainer}>
                                <SelectDropdown
                                    name="BulkStateFilingReferences"
                                    label='Reference Numbers'
                                    value={{label: "All reference numbers", value: ""}}
                                    onSelectCb={(name, selectedOption) => {}}
                                    options={uniqueReferenceList}
                                    dropdownMenuStyle={styles.dropdownMenu}
                                />
                                <p style={styles.noteTxt}>Note: On clicking submit, all the reference numbers visible in the dropdown above will be selected for bulk state filing. </p>
                            </div>
                        }
                    </Loadable>
                    <div style={styles.buttonsContainer}>
                        <Button
                            style={styles.button}
                            disabled={!referenceList.length}
                            onClickCb={() => {
                                if (selectedForm?.value) {
                                    dispatch(getBulkStateFiling({referenceList, FormName: selectedForm?.FormName1}));
                                    dispatch(setFormSelectionModal(false));
                                } else {
                                    dispatch(addNotifications({ heading: "Error", message: "Please select a form & reference number" }))
                                }
                            }}>Submit</Button>

                        <Button
                            style={styles.button}
                            type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                            onClickCb={handleClose}
                        >
                            Cancel
                        </Button>
                    </div>
                </Popup>

                {paymentDrawerModal &&
                    <PaymentDrawer
                        isOpen={paymentDrawerModal}
                        onCloseCb={() => {
                            dispatch(setPaymentDrawerModal(false));
                            handleClose();
                        }}
                        fees={bulkStateAmount}
                        calculatePrepaySalesTax={true}
                        paymentServiceFunctionCb={ManageFormsService.stateFilingPayment}
                        onPaymentSuccessCb={() => { dispatch(setReloadGridData(true)) }}
                        placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.SF_PAYMENT}
                        paymentServiceFunctionExtraParams={{
                            jsonPreferences: uniqueReferenceList.map(record => {
                                return {
                                    key: "true",
                                    ReferenceId: record?.ReferenceID,
                                }
                            }),
                            FormType: selectedForm?.FormName1,
                            PayerId: payerId
                        }}
                    />
                }

            </>}
        </>
    )
}
